import { handleCallback, redirectToLogin } from '../auth/auth';

export function mount(root: HTMLElement): () => void {
  root.innerHTML = '<div class="loading">Signing you in&hellip;</div>';

  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  const error = params.get('error');

  (async () => {
    if (error) {
      // `error` is attacker-controlled query-string input on an unauthenticated
      // route — never interpolate it into innerHTML.
      const div = document.createElement('div');
      div.className = 'auth-error';
      div.textContent = `Login failed: ${error}. `;
      const retry = document.createElement('a');
      retry.href = '/';
      retry.textContent = 'Try again';
      div.appendChild(retry);
      root.replaceChildren(div);
      return;
    }
    if (!code || !state) {
      root.innerHTML = '<div class="auth-error">Missing login response. <a href="/">Try again</a></div>';
      return;
    }
    try {
      await handleCallback(code, state);
      window.history.replaceState({}, '', '/');
      window.location.assign('/');
    } catch (err) {
      console.error(err);
      root.innerHTML = '<div class="auth-error">Login session expired or invalid. Redirecting to login&hellip;</div>';
      await redirectToLogin();
    }
  })();

  return () => {};
}
